<h5 class="card-title" style="padding-top: 10px;">CURSO: {{cou_vc_name}}</h5>

<div class="accordion">
  <ng-container *ngFor="let item of dataAssignFileStudetCourses; let i = index">

    <div class="card">
      <div class="card-header">
        <h2 class="mb-0">
          <button class="btn btn-link btn-block text-left" type="button">
            Modulo : {{ item.mod_vc_name}}
          </button>
        </h2>
      </div>

      <div class="collapse show">
        <div class="card-body">
          <ul>
            <ng-container *ngFor="let item2 of item.detail;">
              <li><a class="pr-2" (click)="viewerFile(item2)">{{item2.stta_vc_file_type}}</a></li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>

  </ng-container>

</div>